import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Translate, I18n } from "react-redux-i18n";
import Tos from 'views/SignUp/components/Tos';
import PrivacyPolicy from 'views/SignUp/components/PrivacyPolicy';
import 'assets/css/footer.css';


const Footer = props => {
 const { isCollapsed, ...rest } = props;

  return (
    <div className={'footer'+(isCollapsed ? ' footer-collapsed' : '')}>
     <span className='text-muted f-14'>
        &copy;{' '}
        <Link
          // component="a"
          to="https://www.ebitrade.com"
          // href="https://www.ebitrade.com"
          target="_blank"
        >
          Ebitrade
        </Link>
        {" "}{new Date().getFullYear()} v1.0.0.2
      </span>
      <p className='text-muted f-14'>
        <Translate value="footer_right" />
      </p>
      <p className="footer-legal-links text-muted f-14">
        <Tos />
        {' · '}
        <PrivacyPolicy />
      </p>
      <Link
        // component="a"
        to="mailto:team@elecsotech.com?subject=Ebi&body=Team%Ebi,"
        // href="mailto:team@elecsotech.com?subject=Ebi&body=Team%Ebi,"
        target="_blank"
        rel="noopener noreferrer"
      >
          team@elecsotech.com
      </Link>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;
